import { v4 as uuidv4 } from 'uuid';
import { callServiceAPI } from './ApiUtils';
var pharmaOmsWebServicesPrefix = "https://api.mypharmafactory.com";

export function addOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/order", "POST", payload, successCallBack, failuerCallback);
}export function addProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/addproduct", "POST", payload, successCallBack, failuerCallback);
}export function updateOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/order", "PUT", payload, successCallBack, failuerCallback);
}export function updateProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/updateproduct", "PUT", payload, successCallBack, failuerCallback);
}export function orderListAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/orderlist", "POST", payload, successCallBack, failuerCallback);
}export function attachPoAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/attachpo", "POST", payload, successCallBack, failuerCallback);
}export function deleteOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/order", "DELETE", payload, successCallBack, failuerCallback);
}export function deleteProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/product", "DELETE", payload, successCallBack, failuerCallback);
}export function submitOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/submitorder", "POST", payload, successCallBack, failuerCallback);
}export function approveOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/approveorder", "POST", payload, successCallBack, failuerCallback);
}export function addCompositionAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/addcomposition", "POST", payload, successCallBack, failuerCallback);
}export function referBackOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/referbackorder", "POST", payload, successCallBack, failuerCallback);
}export function updateProductStatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/updateproductstatus", "PUT", payload, successCallBack, failuerCallback);
}export function approveProductDesignAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/approveProductDesign", "PUT", payload, successCallBack, failuerCallback);
}export function sendDesignToCustomerApprovalAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/senddesigntocustomerapproval", "PUT", payload, successCallBack, failuerCallback);
}export function revokeCustomerApprovalAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/revokecustomerapproval", "PUT", payload, successCallBack, failuerCallback);
}export function addProductRawToDemandAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/addproductrawtodemand", "PUT", payload, successCallBack, failuerCallback);
}export function removeProductRawFromDemandAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/removeproductrawfromdemand", "PUT", payload, successCallBack, failuerCallback);
}export function selectVendorAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/selectvendor", "PUT", payload, successCallBack, failuerCallback);
}export function deselectVendorAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/deselectVendor", "PUT", payload, successCallBack, failuerCallback);
}export function partyApprovalMgmtAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/partyapprovalmgmt", "PUT", payload, successCallBack, failuerCallback);
}export function submitPartyApprovalAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/submitpartyapproval", "PUT", payload, successCallBack, failuerCallback);
}export function updateProductCTidAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/updateproductctid", "PUT", payload, successCallBack, failuerCallback);
}export function accountsApprovalAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/accountsapproval", "PUT", payload, successCallBack, failuerCallback);
}export function qaResponseDesignAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/qaresponsedesign", "PUT", payload, successCallBack, failuerCallback);
}export function submitDesignQaApprovalAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/submitdesignqaapproval", "PUT", payload, successCallBack, failuerCallback);
}export function updateRMstatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/updatermstatus", "PUT", payload, successCallBack, failuerCallback);
}export function updateDesignStatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/updatedesignstatus", "PUT", payload, successCallBack, failuerCallback);
}export function getConfigurationAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/configuration", "POST", payload, successCallBack, failuerCallback);
}export function attachAssetToProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/attachasset", "POST", payload, successCallBack, failuerCallback);
}export function canOrderBeCreatedAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/canorderbecreated", "POST", payload, successCallBack, failuerCallback);
}export function addRepeatProductToOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/addrepeatproducttoorder", "POST", payload, successCallBack, failuerCallback);
}export function attachCommentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/attachcomment", "PUT", payload, successCallBack, failuerCallback);
}export function updateAssetStatusAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/updateassetstatus", "PUT", payload, successCallBack, failuerCallback);
}export function placePMorderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/placepmorder", "POST", payload, successCallBack, failuerCallback);
}export function placeRMorderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/placermorder", "POST", payload, successCallBack, failuerCallback);
}export function getProformaInvoiceAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/getproformainvoice", "POST", payload, successCallBack, failuerCallback);
}export function updateQAinputAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/updateqainput", "PUT", payload, successCallBack, failuerCallback);
}export function receivePMorderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/receivepmorder", "PUT", payload, successCallBack, failuerCallback);
}export function initProdAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/initprod", "PUT", payload, successCallBack, failuerCallback);
}export function canCompleteTaskAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/cancompletetask", "POST", payload, successCallBack, failuerCallback);
}export function preTaskExecutionAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/pretaskexecution", "POST", payload, successCallBack, failuerCallback);
}export function postTaskExecutionAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/postTaskExecution", "POST", payload, successCallBack, failuerCallback);
}export function getNextTaskIdAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/getnexttaskid", "POST", payload, successCallBack, failuerCallback);
}export function preStageExecutionAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/prestageexecution", "POST", payload, successCallBack, failuerCallback);
}export function postStageExecutionAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/postStageExecution", "POST", payload, successCallBack, failuerCallback);
}export function attachQaAssetToProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/attachqaassettoproduct", "PUT", payload, successCallBack, failuerCallback);
}export function GetReportDataAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/getreportdata", "POST", payload, successCallBack, failuerCallback);
}export function editMRPAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/editmrp", "PUT", payload, successCallBack, failuerCallback);
}export function getOrderWithProductsAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/getorderwithproducts", "POST", payload, successCallBack, failuerCallback);
}export function resumeProductAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/resumeproduct", "POST", payload, successCallBack, failuerCallback);
}export function tagOrderForMonthAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/tagorderformonth", "POST", payload, successCallBack, failuerCallback);
}export function getTaggedOrdersAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/gettaggedorders", "POST", payload, successCallBack, failuerCallback);
}export function getWkfListAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/getwkflist", "POST", payload, successCallBack, failuerCallback);
}export function addBiltyAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/addbilty", "POST", payload, successCallBack, failuerCallback);
}export function linkBiltyImageAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/linkbiltyimage", "POST", payload, successCallBack, failuerCallback);
}export function linkProductToBiltyAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/linkproducttobilty", "PUT", payload, successCallBack, failuerCallback);
}export function editPartyAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/editparty", "POST", payload, successCallBack, failuerCallback);
}export function refreshOrderAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/refreshorder", "PUT", payload, successCallBack, failuerCallback);
}export function getMyTaskListAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/getmytasklist", "POST", payload, successCallBack, failuerCallback);
}export function archiveToCurrentAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/archivetocurrent", "POST", payload, successCallBack, failuerCallback);
}export function testLoggerAPI(payload, successCallBack, failuerCallback){

    callServiceAPI(pharmaOmsWebServicesPrefix+"/testlog", "POST", payload, successCallBack, failuerCallback);
}
export function getCompositiontemplateInfoByTitleAPI(title,businessid, setCompositiontemplateList, dataFetchCallBack){
    const requestId = uuidv4().split("-")[4];
    const token = localStorage.getItem("JWT");
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json','X-Request-ID': requestId,'Authorization': `Bearer ${token}` },
    };
    fetch("https://api.mypharmafactory.com/extn/compositiontemplates/title/"+encodeURIComponent(title), requestOptions)
        .then((data) => data.json())
        .then((data) => {
          setCompositiontemplateList(data.list);
          dataFetchCallBack(data.list)
    })
}
